import { IA_KEY } from 'helpers/ia-logic';
import { NAV_KEY } from 'constants/venue-experience';
import { watchColumnActions, PAGE_LAYOUT_VARIANT } from 'features/App';

import {
  watchInstructorsActions,
  handleFormRouteEnter,
  handleRouteEnter,
  handleEditRouteEnter,
} from './Instructors.saga';
import Instructors from './InstructorsContainer';
import InstructorCreateForm from './InstructorForm/InstructorFormContainer';
import InstructorEditForm from './InstructorForm/InstructorEditFormContainer';

export default [
  {
    path: '/manage/:venueId/instructors/:id/edit',
    component: InstructorEditForm,
    iaKey: IA_KEY.MANAGE_INSTRUCTORS,
    navKey: NAV_KEY.INSTRUCTORS,
    locationSagas: [],
    pathSagas: [watchInstructorsActions, watchColumnActions, handleFormRouteEnter, handleEditRouteEnter],
    pageLayout: PAGE_LAYOUT_VARIANT.NARROW,
    hasMultipleColumns: false,
  },
  {
    path: '/manage/:venueId/instructors/create',
    component: InstructorCreateForm,
    iaKey: IA_KEY.MANAGE_INSTRUCTORS,
    navKey: NAV_KEY.INSTRUCTORS,
    locationSagas: [],
    pathSagas: [watchInstructorsActions, watchColumnActions, handleFormRouteEnter],
    pageLayout: PAGE_LAYOUT_VARIANT.NARROW,
    hasMultipleColumns: false,
  },
  {
    path: '/manage/:venueId/instructors',
    component: Instructors,
    iaKey: IA_KEY.MANAGE_INSTRUCTORS,
    navKey: NAV_KEY.INSTRUCTORS,
    locationSagas: [],
    pathSagas: [watchInstructorsActions, watchColumnActions, handleRouteEnter],
    pageLayout: PAGE_LAYOUT_VARIANT.WIDE,
    hasMultipleColumns: true,
    isFixedPage: true,
  },
];
